import { render, staticRenderFns } from "./TableRowActions.vue?vue&type=template&id=bfd3c048&scoped=true"
import script from "./TableRowActions.vue?vue&type=script&lang=js"
export * from "./TableRowActions.vue?vue&type=script&lang=js"
import style0 from "./TableRowActions.vue?vue&type=style&index=0&id=bfd3c048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd3c048",
  null
  
)

export default component.exports